import script from "./ActivationFormView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActivationFormView.vue?vue&type=script&setup=true&lang=ts"

import "./ActivationFormView.vue?vue&type=style&index=0&id=48fe382c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48fe382c"]])

export default __exports__